import "core-js/modules/es.function.name";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import _classCallCheck from "D:/xampp/htdocs/jpuser-dev/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "D:/xampp/htdocs/jpuser-dev/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "D:/xampp/htdocs/jpuser-dev/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "D:/xampp/htdocs/jpuser-dev/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "D:/xampp/htdocs/jpuser-dev/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "D:/xampp/htdocs/jpuser-dev/node_modules/@babel/runtime/helpers/esm/createSuper";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/model/rootelement
 */
import Element from './element';
/**
 * Type of {@link module:engine/model/element~Element} that is a root of a model tree.
 * @extends module:engine/model/element~Element
 */

var RootElement = /*#__PURE__*/function (_Element) {
  _inherits(RootElement, _Element);

  var _super = _createSuper(RootElement);

  /**
   * Creates root element.
   *
   * @param {module:engine/model/document~Document} doc Document that is an owner of this root.
   * @param {String} name Node name.
   * @param {String} [rootName='main'] Unique root name used to identify this root
   * element by {@link module:engine/model/document~Document}.
   */
  function RootElement(doc, name) {
    var _this;

    var rootName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'main';

    _classCallCheck(this, RootElement);

    _this = _super.call(this, name);
    /**
     * Document that is an owner of this root.
     *
     * @private
     * @member {module:engine/model/document~Document}
     */

    _this._doc = doc;
    /**
     * Unique root name used to identify this root element by {@link module:engine/model/document~Document}.
     *
     * @readonly
     * @member {String}
     */

    _this.rootName = rootName;
    return _this;
  }
  /**
   * {@link module:engine/model/document~Document Document} that owns this root element.
   *
   * In contrary, to {@link module:engine/model/node~Node node}, root element always have a `document`.
   *
   * @readonly
   * @type {module:engine/model/document~Document|null}
   */


  _createClass(RootElement, [{
    key: "is",

    /**
     * Checks whether this object is of the given.
     *
     *		rootElement.is( 'rootElement' ); // -> true
     *		rootElement.is( 'element' ); // -> true
     *		rootElement.is( 'node' ); // -> true
     *		rootElement.is( 'model:rootElement' ); // -> true
     *		rootElement.is( 'model:element' ); // -> true
     *		rootElement.is( 'model:node' ); // -> true
     *
     *		rootElement.is( 'view:element' ); // -> false
     *		rootElement.is( 'documentFragment' ); // -> false
     *
     * Assuming that the object being checked is an element, you can also check its
     * {@link module:engine/model/element~Element#name name}:
     *
     *		rootElement.is( '$root' ); // -> true if this is a $root element
     *		rootElement.is( 'rootElement', '$root' ); // -> same as above
     *		text.is( '$root' ); -> false
     *
     * {@link module:engine/model/node~Node#is Check the entire list of model objects} which implement the `is()` method.
     *
     * @param {String} type Type to check when `name` parameter is present.
     * Otherwise, it acts like the `name` parameter.
     * @param {String} [name] Element name.
     * @returns {Boolean}
     */
    value: function is(type, name) {
      var cutType = type.replace('model:', '');

      if (!name) {
        return cutType == 'rootElement' || _get(_getPrototypeOf(RootElement.prototype), "is", this).call(this, type);
      } else {
        return cutType == 'rootElement' && name == this.name || _get(_getPrototypeOf(RootElement.prototype), "is", this).call(this, type, name);
      }
    }
    /**
     * Converts `RootElement` instance to `String` containing it's name.
     *
     * @returns {String} `RootElement` instance converted to `String`.
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.rootName;
    } // @if CK_DEBUG_ENGINE // toString() {
    // @if CK_DEBUG_ENGINE // 	return this.rootName;
    // @if CK_DEBUG_ENGINE // }
    // @if CK_DEBUG_ENGINE // log() {
    // @if CK_DEBUG_ENGINE // 	console.log( 'ModelRootElement: ' + this );
    // @if CK_DEBUG_ENGINE // }

  }, {
    key: "document",
    get: function get() {
      return this._doc;
    }
  }]);

  return RootElement;
}(Element);

export { RootElement as default };